const mixHexColors = (start, end, ratio) => {
  const parse = (color) => {
    const hex = color.replace('#', '');
    if (!/^[0-9a-fA-F]{6}$/.test(hex)) return null;
    return [0, 2, 4].map((offset) => parseInt(hex.slice(offset, offset + 2), 16));
  };
  const startRgb = parse(start);
  const endRgb = parse(end);
  if (!startRgb || !endRgb) return end;
  const mixed = startRgb.map((channel, index) => (
    Math.round(channel + ((endRgb[index] - channel) * ratio))
  ));
  return `rgb(${mixed.join(', ')})`;
};

export const getPriorityColor = (userPriority, theme) => {
  if (userPriority === null || userPriority === undefined || userPriority === '') {
    return theme.palette.text.secondary;
  }
  const numericPriority = Number(userPriority);
  if (!Number.isFinite(numericPriority)) return theme.palette.text.secondary;

  const lowPriorityColor = theme.palette.green?.main || '#39FF14';
  const highPriorityColor = theme.palette.secondary.main;
  const colorRatio = Math.min(1, Math.max(0, (numericPriority - 5) / 5));
  return mixHexColors(lowPriorityColor, highPriorityColor, colorRatio);
};
